<template>
    <div class="px-6 py-3">
        <div v-if="loading" class="flex justify-center items-center h-32">
            <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-opacity-75"></div>
            <p class="ml-3 text-gray-600">Fetching details...</p>
        </div>
        <table v-else class="w-full border-collapse">
            <thead>
                <tr class="bg-gray-200 text-gray-800">
                    <th class="p-3 rounded-tl-lg">Type</th>
                    <th class="p-3">Account No</th>
                    <th class="p-3">Amount</th>
                    <th class="p-3 rounded-tr-lg"></th>
                </tr>
            </thead>
            <tbody v-if="loans.length">
                <tr v-for="(loan, index) in loans" :key="index" class="bg-white shadow-md rounded-lg">
                    <td class="p-3">{{ loan.type_desc }}</td>
                    <td class="p-3">{{ loan.cbsac }}</td>
                    <td class="p-3">{{ loan.amount }}</td>
                    <td class="p-3">
                        <button
                            @click="requestBankStatement(loan)"
                            :disabled="loadingAccount === loan.cbsac"
                            class="px-6 py-2 text-white text-sm font-medium rounded-md"
                            :class="loadingAccount === loan.cbsac ? 'bg-gray-400 cursor-not-allowed' : 'bg-primary hover:bg-blue-700'"
                        >
                            <span v-if="loadingAccount === loan.cbsac">Processing...</span>
                            <span v-else>Bank Statement</span>
                        </button>
                    </td>
                        
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5" class="p-4 text-center text-gray-500">No Loans available</td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>

import { apiRequest } from "@/api";

export default {
    name: 'BankLoans',
    data() {
        return {
            loans: [],
            loading: false,
            loadingAccount: null,
        };
    },
    props: {
        user: Object
    },
    created() {
        this.fetchLoans();
    },
    methods: {
        async requestBankStatement(loan) {
            if (this.loadingAccount === loan.khate) return;
            this.loadingAccount = loan.cbsac;

            let type = '';

            if (loan.type_desc === 'GOLD LOAN') {
                type = "GLN";
            } else if (['HYPOTHICATION LOAN', 'SALARY LOAN-2', 'EASY MONEY LOAN', 'MY MONEY LOAN', 'SALARY LOAN-1', 'HOUSING LOAN', 'EDUCATION LOAN', 'BUSINESS LOAN'].includes(loan.type_desc)) {
                type = 'INL';
            } else if (['USED VEHICLE LOAN', 'VEHICLE LOAN', 'TWO WHEELAR LOAN', 'CAR LOAN', 'COMMERCIAL VEHCLE LOAN'].includes(loan.type_desc)) {
                type = 'VLN';
            } else if (['DL OVERDRAFT LOAN', 'SHORT TEARM GOLD LOAN'].includes(loan.type_desc)) {
                type = 'ODL';
            } else if (loan.type_desc === 'SURETY LOAN') {
                type = 'OTL';
            }


            try {
                const response = await apiRequest('/statements', 'POST', {
                    account: this.user.acno,
                    certno: 0,
                    sub_type: loan.sub_type,
                    type: type,
                    khate: loan.khate
                });

                if (response.data.status === 'success') {
                    sessionStorage.setItem('bankStatement', JSON.stringify(response.data));
                    sessionStorage.setItem('statementSource', 'loan');
                    sessionStorage.setItem('selectedLoan', JSON.stringify(loan));
                    this.$nextTick(() => {
                        this.$router.push('/bankStatement');
                    });
                }

            } catch (error) {
                console.error("Error fetching bank statements:", error);
            } finally {
                this.loadingAccount = null;
            }
        },
        async fetchLoans() {
            this.loading = true;

            try {
                const response = await apiRequest('/loans', 'POST', {});

                if (response.data.status === 'success') {
                    this.loans = response.data.loans
                }

            } catch (error) {
                console.error("Error fetching bank accounts:", error);
            }finally {
                this.loading = false;
            }
        }
    }
}

</script>
<style scoped>

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>